module.exports = __webpack_public_path__ + "static/media/5.6-ext-eval2.0a6aa5f3.png";